//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';

export default {
  name: 'Boeking',
  props: {
    expert: String,
    ajax: String,
    id: '',
  },
  data: function () {
    return {
      loading: true,
      title: '',
      date: '',
      start: '',
      end: '',
      booking_first_name: '',
      booking_last_name: '',
      booking_email: '',
      booking_phone: '',
      session_type: '',
      is_definitive: false,
      cancelled: false,
      review_link: '',
    };
  },
  methods: {
    handleAccept: function () {
      axios.get(`${this.ajax}?action=accept_boeking&id=${this.id}`).then(() => {
        this.is_definitive = true;
        this.$emit('accepted', this.id);
      });
    },
    load: function () {
      if (this.id === '') {
        return;
      }
      this.loading = true;

      axios.get(`${this.ajax}?action=boeking&id=${this.id}`).then(res => {
        const boeking = res.data;

        const {
          title,
          date,
          start,
          end,
          booking_first_name,
          booking_last_name,
          booking_email,
          booking_phone,
          session_type,
          cancelled,
          is_definitive,
          review_link,
        } = boeking;
        this.title = title;
        this.date = date;
        this.start = start;
        this.end = end;
        this.booking_first_name = booking_first_name;
        this.booking_last_name = booking_last_name;
        this.booking_email = booking_email;
        this.booking_phone = booking_phone;
        this.session_type = session_type;
        this.is_definitive = is_definitive;
        this.cancelled = cancelled;
        this.review_link = review_link;

        this.loading = false;
      }).catch(error => {
        console.log(error);
        this.loading = false;
      });
    },
    hasEventPassed: function () {
        const [day, month, year] = this.date.split('-');

        // Create a valid date string for JavaScript (YYYY-MM-DDTHH:MM:SS)
        const formattedDate = `${year}-${month}-${day}T${this.end}`;
        
        // Create a Date object from the formatted string
        const eventDateTime = new Date(formattedDate);
        
        // Check if the current date and time is greater than the event's date and time
        return new Date() > eventDateTime;
    },
  },
  watch: {
    id: function () {
      this.load();
    },
  },
  created: function () {
    this.load();
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/Boekingen/Boeking.vue